export default {"src":"/_next/static/media/gvt.82d351ed.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};